<template lang="pug">
	content-page( v2 pagenav-icon="tune")
		div(slot="nav")
			nav
				accommodations-filter-list(v-if="filterstring" v-model="filterstring")
		nuxt-child
</template>

<script>
import {
	encodeFilters,
	decodeFilters
} from '@dengl/common/utils/filterstrings';
import AccommmodationsFilterList from '@/components/accommodations/filter-list.vue';

export default {
	name: 'AccommodationsSearch',
	components: {
		'accommodations-filter-list': AccommmodationsFilterList
	},
	middleware({ app, route }) {
		if (route.hash) {
			app.filterstring = route.hash.replace('#', '');
		}
	},
	scrollToTop: true,
	// eslint-disable-next-line @milqmedia/milq/page-has-ads, @milqmedia/milq/page-has-meta
	asyncData({ app }) {
		app.ads({
			accosearchresults: { visible: true, type: 'accommodation' }
		});
		return { filterstring: app.filterstring };
	},
	data() {
		return {
			duration: null,
			persons: null,
			destination: null,
			date: null,
			departureModal: false
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	watch: {
		'$route.hash'(val) {
			this.filterstring = val.replace('#', '');
		},
		filterstring(val, oldval) {
			// always push router for /accommodations
			const decodeVal = decodeFilters(val, this.$i18n.locale);
			const decodeOldval = decodeFilters(oldval, this.$i18n.locale);

			if (this.$route.path === '/accommodatie/resultaten' && val.length) {
				if (
					!decodeOldval.date ||
					!decodeOldval.persons ||
					!decodeOldval.duration
				) {
					this.$router
						.replace(
							this.localePath({
								name: 'accommodations-search',
								hash: `#${val}`
							})
						)
						.catch(_e => {});
				} else {
					this.$router.push(
						this.localePath({
							name: 'accommodations-search',
							hash: `#${val}`
						})
					);
				}
			}

			if (
				oldval &&
				val &&
				!['/accommodatie/resultaten', '/accommodatie/mijnreis'].some(path => {
					return this.$route.path.includes(path);
				})
			) {
				const keys = ['date', 'duration', 'persons'];
				keys.forEach(k => delete decodeVal[k]);
				keys.forEach(k => delete decodeOldval[k]);
				const encodeVal = encodeFilters(decodeVal, this.$i18n.locale);
				const encodeOldval = encodeFilters(decodeOldval, this.$i18n.locale);

				if (encodeVal !== encodeOldval) {
					this.$router.push(
						this.localePath({
							name: 'accommodations-search',
							hash: `#${val}`
						})
					);
				} else {
					window.location.hash = `#${val}`;
				}
			}
		}
	},
	mounted() {
		if (this.$route.hash && !this.filterstring) {
			this.filterstring = this.$route.hash.replace('#', '');
		} else if (!this.filterstring) {
			this.$store.commit('SET_SHOW_NAVIGATION_DRAWER', true);
			this.filterstring = '2personen';
		}
	},
	methods: {
		updateMinimum(filters) {
			for (const [filter, value] of Object.entries(filters)) {
				this[filter] = value;
			}
		}
	}
};
</script>
